import { token } from '@atlaskit/tokens';
import { usePathParam } from 'react-resource-router';
import { css } from '@compiled/react';
import { StatsSnapshotWrapper } from '../stats-snapshot/StatsSnapshot';
import { KudosSummaryWrapper } from 'components/profile/main-panel/kudos/KudosSummary';
import { CertificationsSummaryWrapper } from 'components/profile/main-panel/certifications/CertificationsSummary';
import { useScreenType, hasProfileOwnerConsented } from 'utils';
import { GroupsSummaryWrapper } from 'components/profile/groups/GroupsSummary';
import { UnifiedProfileQuery$data } from 'graphql/__generated__/UnifiedProfileQuery.graphql';
import { readInlineData } from 'relay-runtime';
import { UNIFIED_PROFILE_FRAGMENT } from 'graphql/UnifiedProfileFragment';
import { UnifiedProfileFragment$key } from 'graphql/__generated__/UnifiedProfileFragment.graphql';
import { MOBILE } from '../../../constants/breakpoints';
import Events from '../../profile/side-panel/Events';
import { BadgesSummaryWrapper } from './badges';

const MainPanel = ({ data }: { data: UnifiedProfileQuery$data }) => {
  const [pathProfileId] = usePathParam('pathProfileId');
  const screenType = useScreenType();

  const unifiedProfile = data?.unified?.unifiedProfile;
  const profileData =
    unifiedProfile && `__fragments` in unifiedProfile
      ? readInlineData<UnifiedProfileFragment$key>(
          UNIFIED_PROFILE_FRAGMENT,
          data?.unified?.unifiedProfile as NonNullable<
            UnifiedProfileQuery$data['unified']
          >['unifiedProfile'],
        )
      : null;

  const hasProfileOwnerConsent = hasProfileOwnerConsented(
    profileData?.isProfileOwnerConsented ?? undefined,
  );

  return (
    <main css={containerStyles}>
      {profileData?.aaid ? (
        <StatsSnapshotWrapper
          internalId={pathProfileId as string}
          learnId={profileData?.aaid}
          profileHasConsented={hasProfileOwnerConsent}
        />
      ) : null}
      {hasProfileOwnerConsent ? (
        <CertificationsSummaryWrapper
          internalId={pathProfileId as string}
          accountId={profileData?.aaid}
        />
      ) : null}

      <BadgesSummaryWrapper
        internalId={pathProfileId as string}
        profileHasConsented={hasProfileOwnerConsent}
      />
      <KudosSummaryWrapper internalId={pathProfileId as string} />
      {screenType !== 'desktop' ? (
        <>
          <GroupsSummaryWrapper
            internalId={pathProfileId as string}
            isMainPanel={true}
          />
          <Events />
        </>
      ) : null}
    </main>
  );
};
export default MainPanel;

const containerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  alignItems: 'flex-start',
  gap: token('space.600'),
  [`@media (max-width: ${MOBILE.MAX_WIDTH}px)`]: {
    gap: token('space.400'),
  },
});
